/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { DialogActions, Button } from "@mui/material";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";

const DialogTopActions = () => {

    // const selectTab = props.selectTab

    return (
        <Fragment>
            <DialogActions
                className="simplicity-image-selector-window-tabs"
                style={{  }}
            >
                <Button >
                    <GridViewOutlinedIcon />
                    Models
                </Button>
                
            </DialogActions>
        </Fragment>
    );
};

export default DialogTopActions;
